import { render, staticRenderFns } from "./opinion.vue?vue&type=template&id=a5d23e4e&"
import script from "./opinion.vue?vue&type=script&lang=js&"
export * from "./opinion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports